import { createHashHistory } from 'history';
export let History = createHashHistory({ basename: '' });
